<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Manage Fees</h5>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.insertable">
      <div class="col-xl-12">
        <div class="row">
          <!-- Session Select -->
          <div class="col-md-2 col-sm-3 col-12 mb-2">
            <a-spin :spinning="sessionSpinning">
              <a-select
                size="large"
                v-model="selectedSession"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSessionChange"
                :filterOption="false"
                :defaultValue="currentSession ? currentSession.id : ''"
              >
                <template v-for="schoolSession in schoolSessions">
                  <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                      {{schoolSession.name}}
                      <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-sm-3 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="Select Class"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">Select Class</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>

          <!-- Generate Fee -->
          <div class="col-md-8 col-sm-6 col-12 text-sm-right">
            <add-generate-fee @created="handleCreated" @generated="handleCreated" :classId="selectedClass" :sessionId="selectedSession"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.insertable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body" v-if="selectedSession && selectedClass">
            <fees-table :data="data" :loading="loading" :classId="selectedClass" :sessionId="selectedSession" @updateTable="handleUpdateTable" />
          </div>
          <div class="card-body text-center py-5" v-else>
            <a-tag color="purple">
              Please select a Session and Class to view generated fees!
            </a-tag>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
import { mapState } from 'vuex'

import FeesTable from '@/components/feemanagement/manage/Table/index'
import AddGenerateFee from '@/components/feemanagement/manage/Forms/Add/index'

export default {
  components: {
    FeesTable,
    AddGenerateFee,
  },
  beforeMount: function () {
    let rc = this.$roleutility.checkpermission('feemanage', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.getSessions()

    window.Echo.private('GenerateFee.' + this.user.user.id)
      .listen('.StudentFeesGenerated', (e) => {
        this.getGeneratedFees()
      })
  },
  destroyed: function () {
    window.Echo.leave('GenerateFee.' + this.user.user.id)
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      schoolClasses: [],
      schoolSessions: [],
      selectedClass: undefined,
      selectedSession: undefined,
      sessionSpinning: false,
      classSpinning: false,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
    ...mapState(['user']),
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  methods: {
    getSessions: function() {
      this.sessionSpinning = true
      this.$http.get('/api/session')
        .then(({ data }) => {
          this.schoolSessions = data.data
          this.selectedSession = find(data.data, ['is_current', 1]).id
          this.getClasses()
          this.sessionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getGeneratedFees() {
      if (this.selectedClass) {
        this.loading = true
        this.$http.get('/api/fee_setting', {
          params: {
            session_id: this.selectedSession,
            class_id: this.selectedClass,
          },
        })
          .then(({ data }) => {
            this.data = data.data
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
          })
      }
    },
    handleCreated: function() {
      this.getGeneratedFees()
    },
    handleUpdateTable: function() {
      this.getGeneratedFees()
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      if (value) {
        this.getGeneratedFees()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedClass = undefined

      this.getClasses()
      // this.getStudents()
    },
  },
}
</script>
